export default __webpack_public_path__ + "static/media/5 - Контейнеры для сбора лампочек и батареек.9083402e.jpeg";